import React, { useEffect } from "react";
import LoginNavbar from "./LoginNavbar";
import LoginPage from "./LoginPage";
import { useHistory } from "react-router-dom";

export default function Login() {
  const history = useHistory();

  useEffect(() => {
    const itemStr = localStorage.getItem("userData");
    if (itemStr) {
      history.push("/");
    }

    document.title = "VisaPro | Login";
  }, []);

  return (
    <div>
      <LoginNavbar />
      <LoginPage />
    </div>
  );
}
